module.exports = __webpack_public_path__ + "static/media/covi_per_was_san.e950f2c0.png";